import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {ExplainerAddonModelType} from "@/modules/muiutils/models/explainers/ExplainerAddonModelType";
import {Cloneable} from "@/common/Cloneable";

export class ExplainerAddonModel extends Cloneable {

    constructor() {
        super();
        this._type = ExplainerAddonModelType.NONE;
    }

    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ExplainerAddonModel());
        } else if (target instanceof ExplainerAddonModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }

    static schema() {
        return custom((v) => {
            return v ? serialize(ExplainerAddonModel, v) : SKIP;
        }, (v) => {
            return deserialize(ExplainerAddonModel, v);
        });
    }
}

createModelSchema(ExplainerAddonModel, {
    _type: alias("type", ExplainerAddonModelType.schema()),
});